function useStyles() {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            padding: '24px 0',
            margin: '0',
            gap: 2,
            '&.h-full': {
                height: '100%'
            },
            '& .flex-wrap': { flexWrap: 'wrap' },
            '& .flex': { display: 'flex' },
            '& .flex-1': { flex: '1 0 100px' },
            '& .flex-0': { flex: '0 1 100px' },
            '& .detail-container': {
                padding: '0px'
            },
            '& .detail-caption': {
                fontSize: '14px'
            },
            '& .gap-2': { gap: 2 },
            '& .gap-col-2': { columnGap: 2 },
            '& .gap-row-1': { rowGap: 1 },
            '& .break-w': { wordBreak: 'break-word' },
            '& .flex-col': { flexDirection: 'column' },
            '& .w-full': { width: '100%' }
        },
        detailTitle: {
            '& .detail-value': {
                fontSize: '16px',
                fontWeight: '800',
                color: 'c_grey.main'
            },
        },
        detailItem: {
            '& .detail-value': {
                fontSize: '18px',
                fontWeight: 'initial'
            },
        },
    }
}

export { useStyles }